var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.82422C0.75 3.47701 2.65279 1.57422 5 1.57422C7.3472 1.57422 9.25 3.47701 9.25 5.82422C9.25 8.17142 7.3472 10.0742 5 10.0742C2.65279 10.0742 0.75 8.17142 0.75 5.82422ZM5 0.824219C2.23857 0.824219 0 3.06279 0 5.82422C0 8.58562 2.23857 10.8242 5 10.8242C7.7614 10.8242 10 8.58562 10 5.82422C10 3.06279 7.7614 0.824219 5 0.824219ZM4.99655 3.14835C4.97175 2.96538 4.81475 2.82422 4.625 2.82422C4.418 2.82422 4.25 2.99222 4.25 3.19922V6.19922L4.25345 6.25007C4.27825 6.43307 4.43525 6.57422 4.625 6.57422H6.625L6.67585 6.57077C6.85885 6.54597 7 6.38897 7 6.19922C7 5.99222 6.832 5.82422 6.625 5.82422H5V3.19922L4.99655 3.14835Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.abff1ae1708943e4228a2bbcd769b2f7.svg";
export { ForwardRef as ReactComponent };